import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Error404 from '../containers/Error404';
import Deliveries from "../containers/deliveries/Deliveries";

class DeliveryRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/deliveries' component={Deliveries}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default DeliveryRoute;



// WEBPACK FOOTER //
// ./src/routes/DeliveryRoute.js